import { type OaDealStatus, oaDealStatus } from '@openx/types/deal';
import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';

export const useStatus = (
  status?: OaDealStatus
): {
  label: string;
  color: string;
} => {
  const { t } = useTranslation();

  return useMemo(() => {
    switch (status) {
      case oaDealStatus.PAUSED:
        return {
          label: t('Paused'),
          color: 'inactive',
        };
      case oaDealStatus.PUBLISHING:
      case oaDealStatus.READY_FOR_ACTIVATION:
        return {
          label: t('Publishing'),
          color: 'inactive',
        };
      case oaDealStatus.ACTIVE:
        return {
          label: t('Active'),
          color: 'active',
        };
      case oaDealStatus.EXPIRED:
        return {
          label: t('Expired'),
          color: 'warning',
        };
      default:
        return {
          label: t('Error'),
          color: 'error',
        };
    }
  }, [status, t]);
};
